import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import * as packedEggData_1 from './data/packedEgg1.json';
import * as packedEggData_2 from './data/packedEgg2.json';
import * as packedEggData_3 from './data/packedEgg3.json';
import * as eggData from './data/egg.json';
import { SharedService } from '../shared.service';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-vis',
    templateUrl: './vis.component.html',
    styleUrls: ['./vis.component.css']
})
export class VisComponent implements OnInit {

    eventData; // all data from API
    masterData; // master data from API
    graphToRender; // current rendering graph
    tooltipTitle; // titles to pop up when hover on the links of transaction graph
    legendTitle; // title for the legend of graph

    transactionData; // data from all the transaction events
    
    mapView;
    mapData; // sent to vis-map component as input
    
    detailView;
    detailData; // detail data from all events
    detailedData; // sent to vis-detail component as input
    detailedLegendTitle; // sent to vis-detail component as input

    autoZoom;
    panningEnabled;
    zoomLevel;
    update$: Subject<any> = new Subject();
    center$: Subject<any> = new Subject();
    zoomToFit$: Subject<any> = new Subject();

    updateGraph() {
        this.update$.next(true);
    }
    
    centerGraph() {
        this.center$.next(true);
    }

    fitGraph() {
        this.zoomToFit$.next(true);
    }

    onZoomChange($event) {
        // console.log($event);
        this.zoomLevel = $event;
        // console.log(this.zoomLevel);
    }

    onZoomIn() {
        if (this.zoomLevel != 1) {
            this.autoZoom = false;
            this.panningEnabled = true;
            this.zoomLevel = 1;
            console.log(this.zoomLevel);
        }
    }

    onZoomOut() {
        this.autoZoom = true;
        this.panningEnabled = false;
        console.log(this.zoomLevel);
    }

    loadTransactionGraph() {
        this.graphToRender = {
            nodes: [],
            links: []
        };
        let epcidSet = new Set(); // in case of duplication
        for (let i in this.transactionData) {
            let t = this.transactionData[i];
            // add source & destination of each transaction event if not duplicated
            // let s = t.extension.sourceList[0]["urn:epcglobal:cbv:sdt:owning_party"];
            // let d = t.extension.destinationList[0]["urn:epcglobal:cbv:sdt:owning_party"];
            let s = t.source;
            let d = t.destination;
            // let sName = t.extension.sourceName;
            // let dName = t.extension.destinationName;
            let sName = t.sourceName;
            let dName = t.destinationName;
            if (!epcidSet.has(s)) {
                this.graphToRender.nodes.push({
                    id: s,
                    name: sName,
                    epcid: s,
                    label: ""
                });
                epcidSet.add(s);
            }
            if (!epcidSet.has(d)) {
                this.graphToRender.nodes.push({
                    id: d,
                    name: dName,
                    epcid: d,
                    label: ""
                });
                epcidSet.add(d);
            }
            // add a link as the actual transaction after nodes added
            // let date = new Date(t.eventTime.$date);
            // let epcList = [];
            // let tmpEpcSplited = t.epcListStr.split('<epc>');
            // for (let i = 0; i < tmpEpcSplited.length - 1; i++) {
            //     epcList.push(tmpEpcSplited[i+1].split('</epc>')[0]);
            // }
            let tooltipTitle = "[Event Type]: <br />" + t.eventType + "<br /><br />[Event Time]: <br />" + t.eventTime + "<br /><br />[EPC List]: <br />" + t.epcList.join("<br />") + "<br /><br />[Business Location Name]: <br />" + t.bizLocationName + "<br /><br />[Business Location]: <br />" + t.bizLocation;
            this.graphToRender.links.push({
                tid: i,
                epcList: tooltipTitle,
                source: s,
                target: d
            })
        }
        // console.log(this.graphToRender);
        this.mapView = false;
        this.detailView = false;
    }

    loadDetailGraph(eventId) {
        this.detailedData = this.detailData[eventId];
        // this.detailedLegendTitle = this.transactionData[eventId].bizTransactionList[0]["urn:epcglobal:cbv:btt:po"];
        this.detailedLegendTitle = this.transactionData[eventId].bizTransaction;
        this.detailView = true;
    }
    
    showMapView() {
        this.mapView = true;
    }

    parseXMLtoEvent(xmlstr) {
        let eventToReturn;
        let eventTime = xmlstr.split('<eventTime>')[1].split('</eventTime>')[0];
        let eventID = xmlstr.split('<eventID>')[1].split('</eventID>')[0];
        let geoLocation = xmlstr.split('<ext0:location xsi:type="xsd:string">')[1].split('</ext0:location>')[0];
        if (xmlstr.includes('</Transaction')) {
            let bizTransaction = xmlstr.split('<bizTransaction type="urn:epcglobal:cbv:btt:po">')[1].split('</bizTransaction')[0];
            let epcListStr = xmlstr.split('<epcList>')[1].split('</epcList>')[0];
            let epcList = [];
            let tmpEpcListSplited = epcListStr.split('<epc>');
            for (let i = 0; i < tmpEpcListSplited.length - 1; i++) {
                epcList.push(tmpEpcListSplited[i+1].split('</epc>')[0]);
            }
            let action = xmlstr.split('<action>')[1].split('</action>')[0];
            let source = xmlstr.split('<source type="urn:epcglobal:cbv:sdt:owning_party">')[1].split('</source>')[0];
            let destination = xmlstr.split('<destination type="urn:epcglobal:cbv:sdt:owning_party">')[1].split('</destination>')[0];
            let bizLocation = xmlstr.split('<bizLocation>')[1].split('</bizLocation>')[0].split('<id>')[1].split('</id>')[0];
            eventToReturn = {
                'eventTime': eventTime,
                'eventID': eventID,
                'eventType': 'TransactionEvent',
                'geoLocation': geoLocation,
                'bizTransaction': bizTransaction,
                'epcListStr': epcListStr,
                'epcList': epcList,
                'action': action,
                'source': source,
                'destination': destination,
                'bizLocation': bizLocation
            }

            return eventToReturn;

        } else if (xmlstr.includes('</Transformation')) {
            let inputListStr = xmlstr.split('<inputEPCList>')[1].split('</inputEPCList>')[0];
            let inputList = [];
            let tmpInputListSplited = inputListStr.split('<epc>');
            for (let i = 0; i < tmpInputListSplited.length - 1; i++) {
                inputList.push(tmpInputListSplited[i+1].split('</epc>')[0]);
            }
            let outputListStr = xmlstr.split('<outputEPCList>')[1].split('</outputEPCList>')[0];
            let outputList = [];
            let tmpOutputListSplited = outputListStr.split('<epc>');
            for (let i = 0; i < tmpOutputListSplited.length - 1; i++) {
                outputList.push(tmpOutputListSplited[i+1].split('</epc>')[0]);
            }
            let bizLocation = xmlstr.split('<bizLocation>')[1].split('</bizLocation>')[0].split('<id>')[1].split('</id>')[0];
            eventToReturn = {
                'eventTime': eventTime,
                'eventID': eventID,
                'eventType': 'TransformationEvent',
                'geoLocation': geoLocation,
                'inputListStr': inputListStr,
                'inputList': inputList,
                'outputListStr': outputListStr,
                'outputList': outputList,
                'bizLocation': bizLocation
            }

            return eventToReturn;
            
        } else if (xmlstr.includes('</Aggregation')) {
            let parentID = xmlstr.split('<parentID>')[1].split('</parentID>')[0];
            let childEpcStr = xmlstr.split('<childEPCs>')[1].split('</childEPCs>')[0];
            let childEpcList = [];
            let tmpChildListSplited = childEpcStr.split('<epc>');
            for (let i = 0; i < tmpChildListSplited.length - 1; i++) {
                childEpcList.push(tmpChildListSplited[i+1].split('</epc>')[0]);
            }
            let action = xmlstr.split('<action>')[1].split('</action>')[0];
            let bizStep = xmlstr.split('<bizStep>')[1].split('</bizStep>')[0];
            let bizLocation = xmlstr.split('<bizLocation>')[1].split('</bizLocation>')[0].split('<id>')[1].split('</id>')[0];
            eventToReturn = {
                'eventTime': eventTime,
                'eventID': eventID,
                'eventType': 'AggregationEvent',
                'geoLocation': geoLocation,
                'parentID': parentID,
                'childEpcStr': childEpcStr,
                'childEpcList': childEpcList,
                'action': action,
                'bizStep': bizStep,
                'bizLocation': bizLocation
            }

            return eventToReturn;

        } else if (xmlstr.includes('</Object')) {
            let epcListStr = xmlstr.split('<epcList>')[1].split('</epcList>')[0];
            let epcList = [];
            let tmpEpcListSplited = epcListStr.split('<epc>');
            for (let i = 0; i < tmpEpcListSplited.length - 1; i++) {
                epcList.push(tmpEpcListSplited[i+1].split('</epc>')[0]);
            }
            let action = xmlstr.split('<action>')[1].split('</action>')[0];
            let bizStep = xmlstr.split('<bizStep>')[1].split('</bizStep>')[0];
            eventToReturn = {
                'eventTime': eventTime,
                'eventID': eventID,
                'eventType': 'ObjectEvent',
                'geoLocation': geoLocation,
                'epcListStr': epcListStr,
                'epcList': epcList,
                'action': action,
                'bizStep': bizStep
            }

            return eventToReturn;

        } else {
            return null;
        }
    }

    loadEventData(sgtin) {
        this.service.getEventData(sgtin).subscribe(data => {
            // console.log(data);
            let splitedData = data.split('Event>');

            // console.log(splitedData)
            this.eventData = [];
            let inputEPCs = [];
            let eventIDs = new Set();
            for (let i = 0; i < (splitedData.length - 1) / 2; i++) {
                let curr = splitedData[i*2+1];
                let currEventData = this.parseXMLtoEvent(curr);
                // let eventID = curr.split('<eventID>')[1].split('</eventID>')[0];
                // let eventType = curr.split('</').pop();
                // console.log(eventType);
                eventIDs.add(currEventData.eventID);
                this.eventData.push(currEventData);
                if (currEventData.eventType == "TransformationEvent" && currEventData.outputListStr.includes(sgtin)) {
                    // let inputList = curr.split('<inputEPCList>')[1].split('</inputEPCList>')[0].split('<epc>');
                    // let inputList = currEventData.inputListStr.split('<epc>');
                    // for (let j = 0; j < inputList.length - 1; j++) {
                    //     // console.log(inputList[j+1].split('</epc>')[0]);
                    //     inputEPCs.push(inputList[j+1].split('</epc>')[0]);
                    // }
                    inputEPCs.push(...currEventData.inputList);
                }
            }
            // for (var e of data) {
            //     eventIDs.add(e._id.$oid);
            //     if (e.eventType == "TransformationEvent" && e.outputEPCList.filter(epcid => epcid.epc == sgtin).length > 0) {
            //         for (var epc of e.inputEPCList) {
            //             inputEPCs.push(epc.epc);
            //         }
            //     }
            // }
            if (inputEPCs.length > 0) {
                let observables: Observable<any>[] = [];
                for (var epc of inputEPCs) {
                    observables.push(this.service.getEventData(epc));
                }
                forkJoin(observables).subscribe(dataArray => {
                    // console.log(dataArray);
                    let tmpData = [].concat(...dataArray).join('');
                    // console.log(tmpData);
                    let spiltedTmpData = tmpData.split('Event>');
                    
                    for (let k = 0; k < (spiltedTmpData.length - 1) / 2; k++)  {
                        let curr = spiltedTmpData[k*2 + 1];
                        let currEventData = this.parseXMLtoEvent(curr);
                        if (!eventIDs.has(currEventData.eventID)) {
                            this.eventData.push(currEventData);
                        }
                        // if (!eventIDs.has(d._id.$oid)) {
                        //     this.eventData.push(d);
                        // }
                    }
                    // console.log(this.eventData);
                    this.loadTruckDataHelper();
                })
            } else {
                this.loadTruckDataHelper();
            }
        })
    }

    loadTruckDataHelper() {
        let truckEPCs = new Map();
        for (var d of this.eventData) {
            if (d.eventType == "AggregationEvent" && d.parentID.includes("sscc")) {
                let eventTime = new Date(d.eventTime).getTime();
                if (truckEPCs.has(d.parentID)) {
                    truckEPCs.set(d.parentID, [eventTime, ...truckEPCs.get(d.parentID)]);
                } else {
                    truckEPCs.set(d.parentID, [eventTime]);
                }
            }
        }
        let observables: Observable<any>[] = [];
        for (var epc of truckEPCs.keys()) {
            let currTimes = truckEPCs.get(epc);
            let currMin = new Date(Math.min(...currTimes));
            let currMax = new Date(Math.max(...currTimes));
            observables.push(this.service.getObjectEventData(epc, currMin.toISOString(), currMax.toISOString()));
        }
        forkJoin(observables).subscribe(dataArray => {
            // console.log(dataArray);
            for (var arr of dataArray) {
                let splitedArr = arr.split('Event>');
                for (let i = 0; i < (splitedArr.length - 1) / 2; i++) {
                    let curr = splitedArr[i*2 + 1];
                    let currEventData = this.parseXMLtoEvent(curr);
                    this.eventData.push(currEventData);
                }
            }
            this.eventData.sort((a, b) => new Date(a.eventTime).getTime() - new Date(b.eventTime).getTime());
            // console.log(this.eventData);
            this.service.getMasterData().subscribe(data => {
                // console.log(data);
                this.masterData = new Map();
                let n = data.split('bizLocationName').length - 1;
                // console.log(n);
                let splitData = data.split('<VocabularyElement id="')
                // console.log(splitData.length);
                for (let i = 0; i < n; i++) {
                    let curr = splitData[i+1];
                    let id = curr.split('">')[0];
                    let locationName = curr.split('<attribute id="bizLocationName">')[1].split('</attribute>')[0];
                    this.masterData.set(id, locationName);
                }
                // for (var d of data) {
                //     this.masterData.set(d.id, d.attributes.bizLocationName[0]);
                // }
                // // console.log(this.masterData);
                this.loadDataHelper();
            })
        })
    }

    loadDataHelper() {
        let markersContainer = new Map();
        let polylines = [];
        for (var d of this.eventData) {
            if (d.bizLocation != null) {
                d["bizLocationName"] = this.masterData.get(d.bizLocation);
            }
            if (d.eventType == 'TransactionEvent') {
                d["sourceName"] = this.masterData.get(d.source);
                d["destinationName"] = this.masterData.get(d.destination);
                this.transactionData.push(d);
                this.detailData.push([]);
            } else {
                this.detailData[this.detailData.length - 1].push(d);
            }
            
            // console.log(d.any["http://ns．example．com/epcis#location"].coordinates)
            // let loc = pos[0].toString() +','+ pos[1].toString();
            // let pos = d.any["http://ns．example．com/epcis#location"].coordinates;
            let loc : string  = d.geoLocation.split('^geoPoint')[0];
            let pos = loc.replace(' ', '').split(',');
            // let date = new Date(d.eventTime);
            let eventType = d.eventType.split('Event')[0];
            if (markersContainer.has(loc)) {
                let marker = markersContainer.get(loc);
                marker.label.text = marker.label.text + ' / ' + eventType + ': ' + d.eventTime.split('.')[0];
                marker.events.push(d);
            } else {
                let tmpLoc = { lat: parseFloat(pos[0]), lng: parseFloat(pos[1]) };
                if (polylines.length > 0) {
                    polylines[polylines.length - 1].push(tmpLoc);
                }
                polylines.push([tmpLoc]);
                let labelText = eventType + ': '+ d.eventTime.split('.')[0];
                markersContainer.set(loc, {
                    position: tmpLoc,
                    events: [d],
                    label: {
                        color: 'black',
                        text: labelText
                    },
                    options: { animation: google.maps.Animation.DROP, opacity: 0.9 }
                })
            }
            
        }
        // console.log(this.transactionData);
        // console.log(this.detailData);
        this.mapData.markerData = markersContainer;
        this.mapData.polylineData = polylines;
        // console.log(this.mapData);
        this.loadTransactionGraph();
        // console.log(this.detailData);
    }

    constructor(private route: ActivatedRoute, private router: Router, private service: SharedService) {};

    ngOnInit(): void {
        this.autoZoom = true;
        this.panningEnabled = false;
        this.mapData = {};
        this.detailData = [];
        this.transactionData = [];
        
        let sgtin = this.route.snapshot.paramMap.get('sgtin');
        if (sgtin == null) {
            this.legendTitle = "urn:epc:id:sgtin:0000000.000000.0002";
            this.loadEventData(this.legendTitle);
        } else {
            this.legendTitle = sgtin;
            this.loadEventData(sgtin);
        }
    }
}